<template>
  <!-- name: '我要申领' -->
  <div class="applyWrap">
    <img src="https://img.bbalt.cn/imgh5/apply/bg.png" alt="" />
    <h2 class="titleClass">请仔细阅读一下须知后再进行申领</h2>
    <p class="conterClass" v-html="content">      
    </p>
    <ul class="buttonBox">
      <li @click="
        // $router.push({
        //   path: '/other',
        //   query: { title: '申领登记', link: 'https://www.baidu.com' },
        // })
        $toast.fail('暂时不开放此功能');
        "><img src="https://img.bbalt.cn/imgh5/apply/btn_register.svg" alt="" />申领登记</li>
      <li @click="$toast.fail('暂时不开放此功能');">
        <img src="https://img.bbalt.cn/imgh5/apply/btn_record.svg" alt="" />
        申领记录
      </li>
    </ul>
  </div>
</template>

<script>
import { getCmsByCodeApi } from '../../api/cms'
export default {
  components: {},
  data() {
    return {
      code: 'applyNotice',
      content: ''
    }
  },
  created() { 
    this.init()
  },
  methods: {
    init() {
      
      this.queryContent()
    },
    queryContent() {
      const param = {'code': this.code}
      getCmsByCodeApi(param).then(res => {
        if (res.code === 200) {
          this.content = res.content.content
        } else {
          alert(res.message)
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.applyWrap {
  width: 100%;
  height: calc(100% - 100px);
  overflow: hidden;
  padding-bottom: 37px;
  background: #fff;

  img {
    width: 100%;
    height: 320px;
  }

  .titleClass {
    width: 100%;
    height: 42px;
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 42px;
    text-align: center;
    margin-bottom: 24px;
  }

  .conterClass {
    width: 686px;
    max-height: 50%;
    background: #f5f5f5;
    margin: 0px 32px;
    padding: 20px;
    font-size: 26px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 34px;
    text-indent: 30px;
    overflow-y: auto;
  }

  .buttonBox {
    display: flex;
    justify-content: center;
    margin-top: 4%;

    li {
      width: 200px;
      height: 160px;
      border-radius: 16px;
      border: 1px solid #dddddd;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      margin: 0px 35px;

      img {
        width: 72px;
        height: 72px;
        margin-bottom: 4px;
      }
    }
  }
}
</style>
